(function () {
    'use strict';
    'ngInject';

    angular.module('app').config([
        '$routeProvider',
        '$locationProvider',
        function ($routeProvider, $locationProvider) {
            $locationProvider.html5Mode(true);

            $routeProvider.when('/signin', {
                template: require('../views/signin.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/signup', {
                template: require('../views/signup.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/affiliates/signup', {
                template: require('../views/affiliateSignup.html'),
                hasQueryParams: true
            });

            // TODO: check if this route is in use
            $routeProvider.when('/verify', {
                template: require('../views/validation.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/forgotPassword', {
                template: require('../views/forgotPassword.html')
            });

            $routeProvider.when('/passwordReset', {
                template: require('../views/passwordReset.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/emailConfirmation', {
                headerTitle: 'Email Confirmation',
                template: require('../views/pages/emailConfirmation.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/invalidStore', {
                template: require('../views/invalidStore.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/home', {
                headerTitle: 'Templates List',
                template: require('../views/home.html'),
                hasQueryParams: true,
                keepSearch: true
            });

            $routeProvider.when('/stamp/:stampId/:redirectTo?', {
                template: require('../views/stamp.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/retail/collective/:redirectTo?', {
                template: require('../views/retail.html'),
                hasQueryParams: true
            });

            // Product creation
            $routeProvider.when('/createProduct1', {
                headerTitleRight: 'Step 1/3 - Production file settings',
                headerMode: 'dual',
                template: require('../views/pages/create-product/step1.html'),
                reloadOnSearch: false,
                hasQueryParams: true,
                keepSearch: true
            });

            $routeProvider.when('/createProduct2', {
                headerTitleRight: 'Step 2/3 - Preview settings',
                headerMode: 'dual',
                template: require('../views/pages/create-product/step2.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/createProduct3', {
                headerClasses: ['text-left'],
                template: require('../views/pages/create-product/step3.html'),
                hasQueryParams: true
            });

            // Customily Options
            $routeProvider.when('/options', {
                headerTitle: 'Customily Options',
                template: require('../views/pages/product-viewer/customilyOptions.html')
            });

            // Stores
            $routeProvider.when('/store', {
                headerTitle: 'Store',
                template: require('../views/pages/store.html'),
                hasQueryParams: true
            });
            $routeProvider.when('/store/:subPath/', {
                headerTitle: 'Store',
                template: require('../views/pages/store.html'),
                hasQueryParams: true
            });
            $routeProvider.when('/store/create/template/customily-designs', {
                headerTitle: 'Store',
                template: require('../views/pages/store.html'),
                hasQueryParams: true
            });
            $routeProvider.when('/affiliates', {
                headerTitle: 'Affiliates',
                template: require('../views/pages/store.html'),
                hasQueryParams: true
            });
            $routeProvider.when('/earnings', {
                headerTitle: 'Earnings',
                template: require('../views/pages/store.html'),
                hasQueryParams: true
            });

            // Appcues
            $routeProvider.when('/createTemplate', {
                template: require('../views/createTemplate.html'),
                hasQueryParams: true
            });

            $routeProvider.when('/createdProduct/couplemug', {
                headerTitle: 'Templates List',
                template: require('../views/home.html')
            });

            $routeProvider.when('/createdProduct/phone', {
                headerTitle: 'Templates List',
                template: require('../views/home.html')
            });

            $routeProvider.when('/createdProduct/dogmug', {
                headerTitle: 'Templates List',
                template: require('../views/home.html')
            });

            $routeProvider.when('/createdProduct/familycanvas', {
                headerTitle: 'Templates List',
                template: require('../views/home.html')
            });

            $routeProvider.when('/createdProduct/metalsign', {
                headerTitle: 'Templates List',
                template: require('../views/home.html')
            });

            $routeProvider.when('/createdProduct/tote', {
                headerTitle: 'Templates List',
                template: require('../views/home.html')
            });

            $routeProvider.when('/createdProduct/notebook', {
                headerTitle: 'Templates List',
                template: require('../views/home.html')
            });

            /**
             * Vue routes
             */

            const vueRoutesConfig = {
                template: require('../views/pages/vueRouterWrapper.html'),
                reloadOnSearch: false,
                hasQueryParams: true
            };

            $routeProvider.when('/designs', {
                headerTitle: 'Designs',
                ...vueRoutesConfig
            });

            $routeProvider.when('/myProductBases', {
                headerTitle: 'My product bases',
                ...vueRoutesConfig
            });

            $routeProvider.when('/account', {
                headerTitle: 'Account Settings',
                ...vueRoutesConfig
            });

            $routeProvider.when('/account/integrations', {
                headerTitle: 'Account Integrations',
                ...vueRoutesConfig
            });

            $routeProvider.when('/account/billing', {
                headerTitle: 'Account Billing',
                ...vueRoutesConfig
            });

            $routeProvider.when('/account/team', {
                headerTitle: 'Account Team',
                ...vueRoutesConfig
            });

            $routeProvider.when('/account/podBilling', {
                headerTitle: 'Account POD Billing',
                ...vueRoutesConfig
            });

            $routeProvider.when('/libraries', {
                headerTitle: 'Libraries',
                ...vueRoutesConfig
            });

            $routeProvider.when('/libraries/details/:libraryId', {
                headerTitle: 'Libraries',
                ...vueRoutesConfig
            });

            $routeProvider.when('/libraries/details/:libraryId/category/:categoryId/elements', {
                headerTitle: 'Libraries',
                ...vueRoutesConfig
            });

            $routeProvider.when('/pod/productBases', {
                headerTitle: 'POD Product Bases',
                ...vueRoutesConfig
            });

            $routeProvider.when('/canva-oauth-redirect', {
                template: '<div>Redirecting...</div>',
                controller: 'CanvaOAuthRedirectCtrl'
            });

            // Admin
            const adminSettings = {
                headerTitle: 'Admin',
                ...vueRoutesConfig
            };
            $routeProvider.when('/admin', adminSettings);
            $routeProvider.when('/admin/:username', adminSettings);
            $routeProvider.when('/admin/users/:username', adminSettings);
            $routeProvider.when('/admin/designs', adminSettings);

            $routeProvider.when('/', { redirectTo: '/store/podSelection' }).otherwise({ redirectTo: '/' });
        }
    ]);

    // Change Header title
    // https://stackoverflow.com/a/13407227/1519464
    angular.module('app').run([
        '$rootScope',
        '$document',
        '$mdDialog',
        '$location',
        '$window',
        'ConfigService',
        'AuthService',
        function ($rootScope, $document, $mdDialog, $location, $window, ConfigService, AuthService) {
            $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
                $rootScope.showHeader = true;
                if (current.$$route) {
                    // Only when the user was on '/createProduct' we need to clean all params
                    const hasUserBeenInCreatedProductRoute = previous?.$$route.originalPath.includes('/createProduct');
                    const isUserBeingRedirectedOutOfCreateProductRoute = !current.$$route.originalPath.includes(
                        '/createProduct'
                    );

                    // LastCreatedTemplateId is the way of preserving the last created template id in the url to connect the createProduct flow
                    // with the Vuejs app in ShopifyApp/client, this is part of the C20-1767 feature
                    const shouldRouteHaveLastCreatedTemplateId =
                        current.$$route.originalPath === '/store/:subPath/' && hasUserBeenInCreatedProductRoute;

                    if (
                        hasUserBeenInCreatedProductRoute &&
                        isUserBeingRedirectedOutOfCreateProductRoute &&
                        !shouldRouteHaveLastCreatedTemplateId
                    ) {
                        $location.search(''); // Move to the router without parameters
                    }

                    if (shouldRouteHaveLastCreatedTemplateId) {
                        const lastCreatedTemplateId = $location.search().lastCreatedTemplateId;
                        $location.search({ lastCreatedTemplateId });
                    } else {
                        // Catch for cases in which the rest of the query params need to be preserved but the lastCreatedTemplateId param shouldn't
                        const locationSearch = $location.search();
                        delete locationSearch.lastCreatedTemplateId;
                        $location.search(locationSearch); // Move to the router with parameters without lastCreatedTemplateId
                    }

                    if (!current.$$route.keepSearch) $window.localStorage.removeItem('search');

                    ConfigService.setCurrentOriginalPath(current.$$route.originalPath);

                    // Disabled users can only access /home and /account
                    if (!AuthService.isRouteAllowed(current.$$route.originalPath)) {
                        if (AuthService.isCollectiveRetailUser && AuthService.isCollectiveRetailUser()) {
                            $location.path('/store');
                        } else {
                            $location.path('/home');
                        }
                    }

                    if (!current.$$route.hasQueryParams && Object.keys(current.params || {}).length) {
                        $location.search('');
                    }

                    $rootScope.showTemplateResizeBtn = current.$$route.originalPath === '/createProduct1';
                    $rootScope.showCreatePageEpsBtn = false;

                    if (!current.$$route.headerMode) {
                        // Header mode is single by default
                        current.$$route.headerMode = 'single';
                    }

                    $rootScope.headerMode = current.$$route.headerMode;
                    $rootScope.headerTitle = current.$$route ? current.$$route.headerTitle : '';
                    $rootScope.headerTitleLeft = current.$$route ? current.$$route.headerTitleLeft : '';
                    $rootScope.headerTitleRight = $rootScope.beforeMergeProduct
                        ? 'Adjust design placement'
                        : current.$$route
                        ? current.$$route.headerTitleRight
                        : '';

                    $rootScope.headerClasses = (current.$$route ? current.$$route.headerClasses : []) || [];
                    if (!$rootScope.headerClasses.length) {
                        $rootScope.headerClasses = ['text-center'];
                    }

                    // Hide header for open routes
                    if (ConfigService.openRoutes.includes(current.$$route.originalPath)) {
                        $rootScope.showHeader = false;
                    }
                }

                // Close all dialogs on route change
                let count = $document.find('md-dialog').length;
                for (let i = 0; i < count; ++i) {
                    $mdDialog.cancel();
                }
                window.Appcues?.page();
            });
        }
    ]);
})();
